import React, { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { CheckCircle, XCircle, Loader2 } from 'lucide-react';
import axios from 'axios';
import { API } from '@/App';

const VerifyEmailPage = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');
  const [status, setStatus] = useState('loading'); // loading, success, error
  const [message, setMessage] = useState('');

  useEffect(() => {
    if (token) {
      verifyEmail();
    } else {
      setStatus('error');
      setMessage('No verification token found.');
    }
  }, [token]);

  const verifyEmail = async () => {
    try {
      const res = await axios.get(`${API}/auth/verify-email?token=${token}`);
      setStatus('success');
      setMessage(res.data.message);
    } catch (error) {
      setStatus('error');
      setMessage(error.response?.data?.detail || 'Verification failed. The link may have expired.');
    }
  };

  return (
    <div className="min-h-screen bg-[#050505] flex items-center justify-center p-8">
      <div className="w-full max-w-md text-center">
        <div className="flex items-center justify-center gap-3 mb-10">
          <img 
            src="https://customer-assets.emergentagent.com/job_set-roster/artifacts/4vngv49q_2ndTeamStandinsLogoWhite.png" 
            alt="2nd Team Casting" 
            className="h-36 w-auto"
          />
        </div>

        {status === 'loading' && (
          <>
            <Loader2 className="w-12 h-12 text-[#D4AF37] animate-spin mx-auto mb-6" />
            <h1 className="font-['Playfair_Display'] text-2xl font-bold text-white mb-2">Verifying your email...</h1>
          </>
        )}

        {status === 'success' && (
          <>
            <div className="w-16 h-16 rounded-full bg-[#10B981]/20 flex items-center justify-center mx-auto mb-6">
              <CheckCircle className="w-8 h-8 text-[#10B981]" />
            </div>
            <h1 className="font-['Playfair_Display'] text-3xl font-bold text-white mb-4">Email Verified</h1>
            <p className="text-white/60 mb-8">{message}</p>
            <Link to="/login">
              <Button className="gold-gradient text-black font-bold" data-testid="go-to-login-btn">
                Go to Login
              </Button>
            </Link>
          </>
        )}

        {status === 'error' && (
          <>
            <div className="w-16 h-16 rounded-full bg-red-500/20 flex items-center justify-center mx-auto mb-6">
              <XCircle className="w-8 h-8 text-red-400" />
            </div>
            <h1 className="font-['Playfair_Display'] text-3xl font-bold text-white mb-4">Verification Failed</h1>
            <p className="text-white/60 mb-8">{message}</p>
            <Link to="/login">
              <Button variant="outline" className="border-[#D4AF37] text-[#D4AF37]" data-testid="back-to-login-btn">
                Back to Login
              </Button>
            </Link>
          </>
        )}
      </div>
    </div>
  );
};

export default VerifyEmailPage;
